
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from '../../../config.js';

export const useCancelPaymentListMutation = ({ setsnackbarStatus, setActivePaymentList }) => {

    const queryClient = useQueryClient();

    return useMutation({

        mutationFn: () => {


            return axios.post(
                `${config.API_URL}/payment/revertActivePaymentList`,
                {},

                {
                    withCredentials: true
                }

            );
        },
        onSuccess: (data, variables, context) => {
            console.log('onSuccess at useCancelPaymentListMutation',data);
            setActivePaymentList([]);

            queryClient.invalidateQueries({ queryKey: ['ActivePaymentList'], refetchType: 'active' }, { cancelRefetch: false });
            queryClient.invalidateQueries({ queryKey: ['ActivePaymentListAggr'], refetchType: 'active' }, { cancelRefetch: false });
            queryClient.invalidateQueries({ queryKey: ['ArchivePaymentListGroup'], refetchType: 'active' }, { cancelRefetch: false });
            queryClient.invalidateQueries({ queryKey: ['ArchivePaymentList'], refetchType: 'active' }, { cancelRefetch: false });
            queryClient.invalidateQueries({ queryKey: ['PaymentListPatients'], refetchType: 'active'}, {cancelRefetch: false });

            setsnackbarStatus(
                {
                    open: true,
                    message: `Reverted Active Payment List`,
                    severity: 'success'
                }
            )

        },
        onError: (error, variables, context) => {
            console.log(error);

            setsnackbarStatus(
                {
                    open: true,
                    message: `Revert Active Payment List Failed`,
                    severity: 'error'
                }
            )

        }
    })




}